import React from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import Main from './Tabs/Main'
import Staff from './Tabs/YearBudget'
import AcademicWork from './Tabs/AcademicWork/AcademicWork';
import YearBudget from './Tabs/YearBudget';
import TaskForYear from './Tabs/TaskForYear/TaskForYear';
import MethodWork from './Tabs/MethodWork';
import ScintifWork from './Tabs/ScintifWork';
import EducWork from './Tabs/EducWork';
import ProfPreparation from './Tabs/ProfPreparation';
import ContentPlannedWorks from './Tabs/ContentPlannedWorks';

export default function BookmarksOfIndividualWorkPlan({ onRequestClose, setTabIndex, tabIndex, getPdf}) {


  return (

    <div style={{ position: "relative", minHeight: "75vh" }}>
      <div className="close__btn" onClick={onRequestClose}>
        <div className="first" />
        <div className="second" />
      </div>
      <Tabs
        selectedIndex={tabIndex}
        onSelect={tabIndex => setTabIndex(tabIndex)}
      >
        <TabList>
          <Tab
            className="table-mark__years_item"
            selectedClassName="active-item"
            key={0}
            onClick={() => { }}
          >Главная</Tab>
          <Tab
            className="table-mark__years_item"
            selectedClassName="active-item"
            key={2}
          >I ЗАДАЧИ НА УЧЕБНЫЙ ГОД</Tab>
          <Tab
            className="table-mark__years_item"
            selectedClassName="active-item"
            key={3}
          >II ГОДОВОЙ БЮДЖЕТ СЛУЖЕБНОГО (РАБОЧЕГО) ВРЕМЕНИ</Tab>
          <Tab
            className="table-mark__years_item"
            selectedClassName="active-item"
            key={4}
            onClick={() => { }}
          >III Учебная работа</Tab>
          <Tab
            className="table-mark__years_item"
            selectedClassName="active-item"
            key={5}
          >IV Методическая работа</Tab>
          <Tab
            className="table-mark__years_item"
            selectedClassName="active-item"
            key={6}
          >V Научная (научно-исследовательская) работа</Tab>
          <Tab
            className="table-mark__years_item"
            selectedClassName="active-item"
            key={7}
          >VI Воспитательная работа</Tab>
          <Tab
            className="table-mark__years_item"
            selectedClassName="active-item"
            key={8}
          >VII Профессионально-должностная подготовка и другие виды деятельности</Tab>
          <Tab
            className="table-mark__years_item"
            selectedClassName="active-item"
            key={9}
          >VIII Содержание планируемых работ</Tab>

        </TabList>
        <TabPanel key={0}>
          <Main getPdf={getPdf}
          />
        </TabPanel>
        <TabPanel key={1}>
          <TaskForYear
          />
        </TabPanel>
        <TabPanel key={2}>
          <YearBudget
          />
        </TabPanel>
        <TabPanel key={3}>
          <AcademicWork
          />
        </TabPanel>
        <TabPanel key={2}>
          <MethodWork
          //   data={data}
          />
        </TabPanel>
        <TabPanel key={2}>
          <ScintifWork
          //   data={data}
          />
        </TabPanel>
        <TabPanel key={2}>
          <EducWork
          //   data={data}
          />
        </TabPanel>
        <TabPanel key={2}>
          <ProfPreparation
          //   data={data}
          />
        </TabPanel>
        <TabPanel key={2}>
          <Staff
          //   data={data}
          />
        </TabPanel>
        <TabPanel key={2}>
          <Staff
          //   data={data}
          />
        </TabPanel>
        <TabPanel key={2}>
          <ContentPlannedWorks
          //   data={data}
          />
        </TabPanel>
      </Tabs>
    </div>
  )




}
